export default __webpack_public_path__ + "static/media/Ryan Vuscan.91435e49.png";